__webpack_require__.p = "/wp-content/plugins/peachpay-for-woocommerce/public/dist/";